// Spec: .github/specs/maintenance-mode-fe.md
// Fallback defaults used when the maintenance status API omits a field.

export const DEFAULT_AUTO_REFRESH_INTERVAL_SECONDS = 60;
export const DEFAULT_RESTORATION_MESSAGE = '2';
export const DEFAULT_CONTACT_SUPPORT_EMAIL =
  'UPSSCSCaseMgmtMozart@ups.com;UPSSCSDigitalCaseMgmt@ups.com;UPSSCSCaseMgmtSupport@ups.com;';
